import React from "react";

function ItineraryAccordion({ itinerary = [] }) {
  if (!itinerary.length) return null;

  return (
    <div className="accordion mt-4" id="itineraryAccordion">
      <h4 className="mb-3">Itinerary</h4>

      {itinerary.map((day, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
              data-bs-toggle="collapse"
              data-bs-target={`#day${index}`}
            >
              Day {index + 1}: {day.title}
            </button>
          </h2>

          <div
            id={`day${index}`}
            className={`accordion-collapse collapse ${
              index === 0 ? "show" : ""
            }`}
          >
            <div className="accordion-body">
              {day.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ItineraryAccordion;
